import { Slider } from 'almanac-ui/Slider/Slider'
import { SafeNumberInput } from 'almanac-ui/TextInputField/SafeNumberInput'
import Styles from 'common/Prose/nodeViews/Image/components/ImageVariant/ImageVariant.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { useId } from '@react-aria/utils'
import { useState } from 'react'
import { flatten } from 'lodash'
import { SliderProps } from 'almanac-ui/Slider/Types'

interface Props extends Pick<SliderProps, 'maxValue' | 'minValue' | 'step' | 'label' | 'pinnedValue'> {
  onChangeEnd: (value: number) => void
  initialValue?: number
}

export const SliderField = ({ minValue, maxValue, onChangeEnd, initialValue, step, label, ...rest }: Props) => {
  const id = useId()
  const [localValue, setLocalValue] = useState(initialValue)

  const clampValue = (val: number) => {
    return Math.min(Math.max(val, minValue ?? -Infinity), maxValue ?? Infinity)
  }

  return (
    <div className={Styles.sliderField}>
      <div className={Styles.label}>
        <Text variant="smallList" id={id}>
          {label}
        </Text>
      </div>

      <div className={Styles.controls}>
        <Slider
          {...rest}
          filled
          aria-labelledby={id}
          minValue={minValue}
          maxValue={maxValue}
          step={step}
          onChange={(value) => setLocalValue(clampValue(flatten([value])[0]))}
          value={localValue}
          onChangeEnd={(value) => {
            onChangeEnd(clampValue(flatten([value])[0]))
            setLocalValue(clampValue(flatten([value])[0]))
          }}
        />
        <SafeNumberInput
          aria-labelledby={id}
          className={Styles.numberInput}
          name="brightness"
          size="xs"
          value={localValue}
          placeholder="--"
          onChange={(value) => {
            onChangeEnd(clampValue(flatten([value])[0]))
            setLocalValue(clampValue(flatten([value])[0]))
          }}
          minValue={minValue}
          maxValue={maxValue}
          step={step}
          withBorder={false}
          autoComplete="off"
        />
      </div>
    </div>
  )
}
